import {canManagePeople} from '@netx/core-person/enablers/canManagePeople';

export const canManageSystemPeople = () => canManagePeople();
